import { DateRangeOption } from '../../../../graphql/schema';

export const DateRangeFilter: React.FC<{
  onChange: (option: DateRangeOption) => void;
  selected: DateRangeOption;
}> = ({ onChange, selected }) => {
  return <div>Placeholder: Date range filter</div>;
};
